// What is playing right now. Single store for every reader (player state machine, EPG);
// each entry point feeds it from its own owner: the ui6 player in index.js, the
// /v7/live_events poll in the standalone EPG.
let liveContent = null;

const LiveContentStore = {
    get: () => liveContent,
    set: (next) => {
        liveContent = next ?? null;
        window.dispatchEvent(new CustomEvent('LiveContentUpdate', { detail: liveContent }));
    }
};

export default LiveContentStore;
